/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import * as S from './style'
import arrowBack from '../../assets/icons/arrow_back.svg'
import arrowForward from '../../assets/icons/arrow_forward.svg'

import { useControllerPaginationFooterV2 } from './useViewController'
import { PaginationFooterPropsV2 } from './Models'

export const PaginationFooterV2WithTotal = ({
  changePage,
  limit,
  offset,
  loading,
  page,
  setPage,
  limitedSpace,
  label,
  customStyles,
  children,
  hasMore,total
}: PaginationFooterPropsV2) => {
  const { paginRange, inputPage,paginMax } = useControllerPaginationFooterV2({
    changePage,
    limit,
    offset,
    loading,
    page,
    setPage,
    limitedSpace,
    label,
    customStyles,
    hasMore,total
  })

  return (
    <S.Wrapper style={customStyles}>
      <div className="pagination_footer_row">
        <p className="pagination_footer_text">
          {'Mostrando '}
          <span className="pagination_footer_strong">{paginRange()}</span>
        </p>
        {children}
      </div>

      <div className="pagination_footer_row">
        <p className="pagination_footer_text">{paginMax()}</p>
        <S.PaginationButtons>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              if (page > 1 && !loading) changePage(false)
            }}
            className={`pagination_footer_button ${
              loading || page <= 1 ? 'pagination_footer_off' : ''
            }`}
          >
            <img src={arrowBack} alt="back" />
            {/* <FontAwesomeIcon style={{width:16,height:16}} icon={faArrowLeft} /> */}
          </button>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              if (!loading && hasMore) changePage(true)
            }}
            className={`pagination_footer_button ${
              loading || !hasMore ? 'pagination_footer_off' : ''
            }`}
          >
            <img src={arrowForward} alt="foward" />

            {/* <FontAwesomeIcon
              style={{ width: 16, height: 16 }}
              icon={faArrowRight}
              color="#212121"
            /> */}
          </button>
        </S.PaginationButtons>
      </div>
    </S.Wrapper>
  )
}
